import { Component } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Location } from "@angular/common";
import { ApiService } from './shared/api.service';
import { IMMEvent } from 'src/app/model/imm-event/imm-event.model';
import { IMMEventService } from 'src/app/shared/immEevent-service/imm-event.service';
import { authRoutes } from 'src/app/app-routing.module';
import { NotificationService } from './shared/notification.service';
import { MatDialog } from '@angular/material/dialog';
import { UnauthDialogComponent } from './unauth-dialog/unauth-dialog.component';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'MyAnatomy';
  errorMessage: String = '';
  static sessionCallLock: Boolean = false;

  logout() {
    ApiService.clearSessionObject();
    window.location.assign(this.apiService.getDefaultRedirectionURL());  
  }

  isExpanded = false;
  element: HTMLElement;
  currentRoute: boolean = true;
  url: string;

  private eventId = this.apiService.getEventId();
  eventName: string;
  eventDetails: IMMEvent;

  ngOnInit() {
    this.redirectRouter();
  }

  public sessionExpireRedirectCheck() {
    if (!this.apiService.getSessionId()) {
      ApiService.clearSessionObject();
      setTimeout(() => this.route.navigate(['/login/auth/uus'], { queryParams: {sessionExpired: true} }), 1000);
    }
  }

  redirectRouter() {
    this.route.events.subscribe((event) => {
      this.url = this.location.path();
      let rootPathName = this.url.split('/')[1];
      rootPathName = rootPathName.includes("?") 
                     ? rootPathName.split("?")[0]
                     : rootPathName;
      if (authRoutes.includes(rootPathName)) {
        
        this.currentRoute = true;
        this.sessionExpireRedirectCheck();
      } else {
        this.currentRoute = false;
        if (this.url && this.url.includes('/login/auth/uus?')) {
          this.getQueryParams();
        }
      }
    });
    
  }

  


  constructor(
    private eventService: IMMEventService,
    private apiService: ApiService,
    private route: Router,
    private location: Location,
    private activatedRoute: ActivatedRoute,
    private notificationService: NotificationService,
    private dialog: MatDialog
  ) { 
    this.eventName = apiService.getEventName();
    
  }

  validateQueryParams(params) {
    const defaultParams = {
      uusToken: true,
      testId: true,
      eventId: true,
      client: true,
      candidateDataSource: true,
      eventMetadataSource: true,
      landingUrl: true,
      redirectUrl: true
    };

    const listOfInvokedParams = Object.keys(params);
    if(!(listOfInvokedParams && listOfInvokedParams.length)) {
      return false;
    }

    var isValidParams = true;

    for (var param of listOfInvokedParams) {
      if (!defaultParams[param]) {
        isValidParams = false;
        break;
      }
    }

    return isValidParams;
  }

  redirectedToAuthRoute() {
    if (this.apiService.getLandingURL()) {
      setTimeout(() => this.route.navigate([
                          this.apiService
                              .getLandingURL()
                              .replace(ApiService.selfDomain,'')
                        ]), 1000);
      ;
    } else {
      this.route.navigate(['/dashboard'])
    }
    this.removeSessionLock();
  }

  openUnAuthDialog(errorMessage): void {
    const dialogRef = this.dialog.open(UnauthDialogComponent, {
      width: '250px',
      data: { errorMessage }
    });
  }

  removeSessionLock() {
    setTimeout(() => (AppComponent.sessionCallLock = false), 3000);
  }
  applySessionLock() {
    AppComponent.sessionCallLock = true;
  }
  getQueryParams() {
    this.activatedRoute.queryParams.subscribe((params) => {
      if (!AppComponent.sessionCallLock) {
        if (this.validateQueryParams(params)) {
          this.applySessionLock();
          this.apiService.verifySession(params)
            .then(res => {
              this.apiService.setSessionObject({
                ...res,
                redirectUrl: params.redirectUrl,
                landingUrl: params.landingUrl,
                eventName: res.eventName
              });
              this.eventName = res.eventName;
              this.errorMessage = "";
              this.currentRoute = true;
              this.redirectedToAuthRoute();
            })
            .catch(err => {
              this.errorMessage = "Unauthorized Access";
              this.currentRoute = false;
              ApiService.clearSessionObject();
              // this.notificationService.warn(this.errorMessage);
              this.openUnAuthDialog(this.errorMessage);
              this.removeSessionLock();
            });
        } else if (params.sessionExpired) {
          this.applySessionLock();
          this.errorMessage = "Session Expired";
          this.openUnAuthDialog(this.errorMessage);
        }
      }
    });
  }

  toggleActive(event:any){
    // debugger;
    event.preventDefault();
    if(this.element !== undefined){
      this.element.style.backgroundColor = "white";
    } 
    var target = event.currentTarget;
    target.style.backgroundColor = "#cfcecc";
    this.element = target;
  }

  onGoBackClick() {
    const goBackStatus = window.confirm('Confirmation\n\nAre you sure to go back?');
    
    if (goBackStatus) {
      let redirectionURL = this.apiService.getDefaultRedirectionURL();
      ApiService.clearSessionObject();
      window.location.assign(redirectionURL);
    }
  }
  getEvent() {
    this.eventService.findById(this.eventId).then(
      eventDetail => {
        this.eventDetails = eventDetail;
        this.eventName = this.eventDetails.eventName;
      }
    );
  }

}
